// Shared list of supported languages across the platform
export const SUPPORTED_LANGUAGES = [
  'English',
  'French',
  'Spanish',
  'German',
  'Russian',
  'Chinese',
  'Portuguese',
  'Arabic',
  'Urdu',
  'Hindi',
  'Japanese',
  'Korean',
  'Italian',
  'Dutch',
  'Polish',
  'Turkish',
  'Greek',
  'Thai',
] as const;

export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number];
